import { TileLabelProps } from "./types";
import { HStack } from "@gluestack-ui/themed";
import { Text } from "@repo/core/components/core/Text";

export const TileLabel = ({
  text,
  fontColor = "$textLight800",
  fontSize = "sm",
  fontFamily = "inter",
  fontWeight = 400
}: TileLabelProps) => {
  return (
    <HStack alignItems="center" width="$full">
      <Text
        size={fontSize}
        family={fontFamily}
        fontWeight={fontWeight}
        numberOfLines={1}
        color={fontColor}
        flex={1}
      >
        {text}
      </Text>
    </HStack>
  );
};
